var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TasksEditor"},[_c('div',[_c('div',{staticClass:"TasksEditor bntGroup"},[_c('base-button',{staticClass:"no-border my-0",attrs:{"type":"primary","simple":"","icon":""},on:{"click":function($event){return _vm.GoToEdit(false)}}},[_c('i',{staticClass:"d-inline-block tim-icons icon-simple-remove"})])],1),_c('ReTasksEdit')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }